import { render, staticRenderFns } from "./OrderAdminLeft.vue?vue&type=template&id=3502ac48&scoped=true&"
import script from "./OrderAdminLeft.vue?vue&type=script&lang=js&"
export * from "./OrderAdminLeft.vue?vue&type=script&lang=js&"
import style0 from "./OrderAdminLeft.vue?vue&type=style&index=0&id=3502ac48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3502ac48",
  null
  
)

export default component.exports